import React from 'react'

export const InvoiceDetail = () => {
    return <div>InvoiceDetail</div>
}
